import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { format } from 'date-fns';
import { getDate } from '../../configInfo/components/Functions';
import { log } from './Interfaces';
interface Props {
  log: log;
  delay: number;
  animate: boolean;
}

const Log: React.FC<Props> = ({ log, delay, animate }) => {
  let date = format(getDate(new Date(log.dateUTC)), 'MM/dd/yyyy, hh:mm:ssaaa');
  if (animate) {
    return (
      <div className="log">
        <Card>
          <CardContent>
            <Typography variant="body1">
              <b>Date: </b>
              {date}
            </Typography>
            <Typography variant="body1">
              <b>Lead Type: </b>
              {log.leadType}
            </Typography>
            <Typography variant="body1">
              <b>Lead Status Type: </b>
              {log.leadStatusType}
            </Typography>
            <Typography variant="body1">
              <b>Lead Status Text: </b>
              {log.leadStatusText}
            </Typography>
          </CardContent>
        </Card>
      </div>
    );
  } else {
    return (
      <div className="log">
        <Card>
          <CardContent>
            <Typography variant="body1">
              <b>Date: </b>
              {date}
            </Typography>
            <Typography variant="body1">
              <b>Lead Type: </b>
              {log.leadType}
            </Typography>
            <Typography variant="body1">
              <b>Lead Status Type: </b>
              {log.leadStatusType}
            </Typography>
            <Typography variant="body1">
              <b>Lead Status Text: </b>
              {log.leadStatusText}
            </Typography>
          </CardContent>
        </Card>
      </div>
    );
  }
};

export default Log;
